<template>
	<div class="">
		<header-vue></header-vue>
		<div class="login login2">
		   
		    <div class="log-email" v-if="!ifSecond">
		    	<h3>
		    		验证密码
		    	</h3>
		    	<br />
		    	<input placeholder="请输入当前账号密码" v-model="nowPass" type="password" class="log-input log-input-empty" />
		    	<br />
		    	<br />
		    	<br />
		        <a href="javascript:;" class="log-btn" @click="validationPass()">验证</a>
		    </div>
		    <div class="log-email" v-if="ifSecond">
		    	<h3>
		    		获取新账号验证码
		    	</h3>
		    	<p class="log_warn" v-if="ifwarn" v-text="warntxt"></p>
		    	<input placeholder="请输入新手机号" v-model="username" class="log-input log-input-empty" />
		    	<div class="relative-box">
		    		<input placeholder="验证码" v-model="code" class="log-input log-input-empty" />
		    		<el-button @click="getcode" class="getcode" type="primary" :disabled="isDisabled">{{buttonName}}</el-button>
		    	</div>
		        <a href="javascript:;" class="log-btn" @click="transferAccount()">确认移交</a>
		    </div>
		   
		</div>
	</div>
</template>
<script>
let sha256=require("js-sha256").sha256;
export default {
  name: 'app',
  data(){
    return {
    	ifSecond:false,
    	nowPass:"",
    	buttonName: "获取验证码",
    	username:"",
    	isDisabled:false,
    	code:"",
    	ifwarn:false,
  		warntxt:'',
  		time:60
    }
  },
  mounted(){
    this.$nextTick(function(){
    	
  	})
  },

  methods: {
	validationPass(){
		let valiCodeParams={
			uid:this.getCookie('uid'),
			password:sha256(this.nowPass),
	  		time:Date.parse( new Date()),
	  		terminalId:4,
  		};
  		this.sign(valiCodeParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/UserTransfer/PsdVerification",this.$qs.stringify(valiCodeParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1){
        		this.$message.success(res.data.msg);
        		this.ifSecond = true;
        	}else if(res.data.code==10008){
			      this.delCookie('username');
			      this.$router.push('/login/');
					this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
        	}else{
        		this.$message.error(res.data.msg);
        	}
  		});
	},
	getcode() {
		this.ifwarn = false;
		this.warntxt = '';
		var reg=11 && /^(1\d{10})$/;
		if(this.username==""){
			this.ifwarn = true;
			this.warntxt = '手机号不能为空';
		}
		else if(!reg.test(this.username)){
			this.ifwarn = true;
			this.warntxt = '请输入正确的手机号码';
		}
		else{
			this.sendMsg();
			let getcodeParams={
				uid:this.getCookie('uid'),
	  			username:this.username,
	  			timestamp:Date.parse( new Date()),
	  			terminalId:4,
	  		};
	  		this.sign(getcodeParams);
	  		this.$ajax.post(this.$store.state.domain+"/Home/SendTransfer/SendTransfer",this.$qs.stringify(getcodeParams),{
	            emulateJSON: true
	        }).then(res=>{
	        	if(res.data.status==1){
	        		//console.log("验证码发送成功");
	        		
	        	}else if(res.data.code==10008){
	        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
	        	}else{
	        		//console.log(res.data.msg);
	        		this.ifwarn = true;
	        		this.warntxt = res.data.msg;
	        	}
	  		});
		}
		
  		
  		
	},
	transferAccount(){
				
		if(this.newPass==this.comfirNewPass && this.code!=''){

			let transferAccountParams={
				username:this.username,
				code:this.code,
				time:Date.parse( new Date()),
	  			terminalId:4,
	  			uid:this.getCookie('uid'),
	  		};
	  		this.sign(transferAccountParams);
	  		this.$ajax.post(this.$store.state.domain+"/Home/UserTransfer/Tieup",this.$qs.stringify(transferAccountParams),{
	            emulateJSON: true
	        }).then(res=>{
	        	if(res.data.status==1){
	        		//console.log("验证码发送成功");
	        		this.$message.success('账户移交成功，将跳转到登录页!');
	        		var that = this;
	        		setTimeout(function(){ 
	        			that.$router.push('/login');
	        		}, 3000);
	        		
	        	}else if(res.data.code==10008){
	        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
	        	}else{
	        		//console.log(res.data.msg);
	        		this.ifwarn = true;
	        		this.warntxt = res.data.msg;
	        	}
	  		});
		}
		else{
			this.ifwarn = true;
			this.warntxt = '请填写验证码';
		}
		
		
	},
	
	
  }
}
</script>


<style scoped="">
	.log-email{
		position: relative;
	}
	.login{
		min-height: 0;
		width: 415px;
		padding-bottom: 20px;
	}
	.log-bg{
		height: 0px;
	}
	.log-logo{
		margin-top: 20px;
		margin-bottom: 0px;
		height: 60px;
	}
	.log_warn{
		position: absolute;
		top: 100px;
		left: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/accountTransfer.vue